import React from 'react';
import './main.less';

import { Link } from 'react-router';

import wrapMain from '../wrap-main';

function BannersManual() {
	return (
		<div className='banners-manual'>
			<div>
				To create a banner:
			</div>
			<ol>
				<li>
					<div>
						<Link to='/banners/campaigns'>
							In the "Campaigns" tab
						</Link> - information about banner campaigns (placing banners in the dashboard).
					</div>
					<div>
						Adding campaigns is handled by the developer.
					</div>
				</li>
				<li>
					<div>
						<Link to='/banners/images'>
							In the "Images" tab
						</Link> - information about the images that will be used to create banners.
					</div>
					<div>
						To create an image - click on the <Link to='/banners/images/editor'>
							"Create banner image"
						</Link> button.
						Enter a title and language used in the image (required for easy search of banner images).
					</div>
				</li>
				<li>
					<div>
						<Link to='/banners/contents'>
							In the "Contents" tab
						</Link> - information about the content of the banner.
					</div>
					<div>
						To create content - click on the <Link to='/banners/contents/editor'>
						"Create banner content"</Link> button.
						Enter a title and, for each desired language, specify the banner content.
						English and Russian are required.
						For all others, English content will be used by default.
						Enter image link and link to redirect the user (optional).
						To search for images based on the current language - click on the search button
						to the right of the input field.
						Then copy the link to the image in the "actions" column.
						If you want the link to open in a new tab - check the "Is blank" box.
						In order to change the image at intervals, add new content by clicking
						on the "Add banner content" button and also specify the fields and the time interval
						after which the content will change (in milliseconds, 1 second = 1000 milliseconds).
					</div>
				</li>
				<li>
					<div>
						<Link to='/banners/publications'>
							In the "Publications" tab
						</Link> - information about banner publications sorted by the date
						the banner was applied (by the date of the scheduled publication (display at) or otherwise
						by the date of creation (created at)).
					</div>
					<div>
						To create publication - click on the <Link to='/banners/publications/editor'>
						"Create banner publication"</Link> button.
						Fill the form. The field "Display at" - the date of the scheduled publication is optional.
						If this field is not filled in, the date when the banner was applied
						will be the date of its creation.
					</div>
				</li>
			</ol>
		</div>
	);
}

export default wrapMain(BannersManual);


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/banners/manual/main.js